module.exports = __webpack_public_path__ + "img/settings.487d772f.svg";